import CloseIcon from '@mui/icons-material/Close';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import {Box, Divider, IconButton, Tooltip} from '@mui/material';
import {useState} from 'react';

import {AlarmHistoryListQuery} from '../../../interfaces/AlarmsHistory';
import {ExportField} from '../../../interfaces/Export';
import ExportPdfButton from '../../common/ExportPdfButton';
import ModalFixed from '../../common/ModalFixed';
import AlarmHistoryTrackingReportsExportExcel from './AlarmHistoryTrackingReportsExportExcel';

interface Props {
  alarmId?: number;
  params?: AlarmHistoryListQuery;
  exportFields?: ExportField[];
}

const AlarmHistoryTrackingReportsExportButton = ({
  alarmId,
  params,
  exportFields,
}: Props) => {
  const [isOpened, setIsOpened] = useState(false);

  return (
    <>
      <Tooltip title="Export">
        <FileDownloadIcon onClick={() => setIsOpened(true)} />
      </Tooltip>

      {isOpened ? (
        <ModalFixed open={isOpened} onClose={() => setIsOpened(false)}>
          <Box
            display="flex"
            flexDirection="column"
            position="relative"
            gap={3}
            p={3}
          >
            <Box display="flex" justifyContent="space-between">
              <Box display="flex" alignItems="center" width="100%" gap={1.5}>
                <FileDownloadIcon sx={{color: 'primary.main'}} />
                <Box fontSize={24}>Export Alarm History</Box>
              </Box>
              <IconButton onClick={() => setIsOpened(false)}>
                <CloseIcon />
              </IconButton>
            </Box>

            <Box
              display="flex"
              flexDirection="column"
              position="relative"
              gap={3}
            >
              <Divider>Export</Divider>
              <AlarmHistoryTrackingReportsExportExcel
                alarmId={alarmId}
                params={params}
              />
              <ExportPdfButton
                endpoint={`/alarm-module/${alarmId}/history`}
                defaultFilename="alarm_history.pdf"
                params={params as Record<string, unknown> | undefined}
                exportFields={exportFields}
              />
            </Box>
          </Box>
        </ModalFixed>
      ) : null}
    </>
  );
};

export default AlarmHistoryTrackingReportsExportButton;
